import { client } from '@/shared/api';
const PATH_AUTH_API = 'Admin';
export const getSystemInstanceInfo = async () => {
    const { data } = await client.get(`${PATH_AUTH_API}/SystemInstanceInfo`);
    if (!data.isSuccess) {
        throw new Error(`SystemInstanceInfo. ${data.errorMessage}`);
    }
    return data;
};
